<template>
  <div>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row class="no-gutters">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select solo :items="slots" append-icon="mdi-chevron-down" label="All Accounts"
            class="custom-select"></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px" class="">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateRangeText" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down" readonly
                v-bind="attrs" v-on="on" solo></v-text-field>
            </template>
            <v-date-picker v-model="date" class="custom-date-picker" scrollable range>
              <v-spacer></v-spacer>
              <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="modal = false"> Cancel </v-btn>
              <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="$refs.dialog.save(date)">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="12" md="5" lg="7">
          <ul class="chart-field-info">
            <li>
              <span>Total Equity:</span>
              <span>129050</span>
            </li>
            <li>
              <span>Total Lot:</span>
              <span>12.90</span>
            </li>
            <li>
              <span class="profit-loss">Profit / Loss:</span>
              <span>-20000</span>
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <v-card class="pa-3 rounded-0 elevation-0 chart-tab" :color="$vuetify.theme.dark ? '#172233' : '#E0EAF2'">
            <v-card-title>
              <v-icon class="blink" color="#FF567F"> mdi-circle-small </v-icon>
              Live Trading Profit / Loss History
            </v-card-title>
            <v-sheet class="pb-3" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#E8F1F8'">
              <apexChart width="100%" height="338px" type="bar" :options="options" :series="series"
                class="liveTradeChart">
              </apexChart>
            </v-sheet>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row class="no-gutters">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select solo :items="slots" append-icon="mdi-chevron-down" label="All Accounts"
            class="custom-select"></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px" class="">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateRangeText" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down" readonly
                v-bind="attrs" v-on="on" solo></v-text-field>
            </template>
            <v-date-picker v-model="date" class="custom-date-picker" scrollable range>
              <v-spacer></v-spacer>
              <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="modal = false"> Cancel </v-btn>
              <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="$refs.dialog.save(date)">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="12" md="5" lg="7">
          <ul class="chart-field-info">
            <li>
              <span>Total Equity:</span>
              <span>129050</span>
            </li>
            <li>
              <span>Total Lot:</span>
              <span>12.90</span>
            </li>
            <li>
              <span class="profit-loss">Profit / Loss:</span>
              <span>-20000</span>
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <v-card class="pa-3 rounded-0 elevation-0 chart-tab" :color="$vuetify.theme.dark ? '#172233' : '#E0EAF2'">
            <v-card-title>
              <v-icon large color="#708AA7"> mdi-circle-small </v-icon>
              Closed Trades Profit / Loss History
            </v-card-title>
            <v-sheet class="pb-3" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#E8F1F8'">
              <apexChart width="100%" height="338px" type="bar" :options="options" :series="series"
                class="liveTradeChart">
              </apexChart>
            </v-sheet>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slots: ["7100001492(MICRO)", "7100006392(MICRO)", "7102006392(MICRO)"],
      date: ["2022-01-01", this.getCurrentDate()],
      modal: false,
      options: {
        chart: {
          id: "vuechart-example",
          type: "bar",
          height: "338px",
          theme: "dark",
        },

        xaxis: {
          labels: {
            style: {
              colors: [
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
                "#708AA7",
              ],
            },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: ["#708AA7"],
            },
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "40%",
          },
        },
        colors: ["#039de9"],
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          show: true,
          showForSingleSeries: true,
          customLegendItems: ["Profit", "Loss"],
          labels: {
            colors: ["#647E98"],
            useSeriesColors: false,
          },
          markers: {
            fillColors: ["#14D7B2", "#647E98"],
            radius: 12,
          },
        },
      },
      series: [
        {
          name: "Actual",
          data: [
            {
              x: "01/01",
              y: 4000,
            },
            {
              x: "02/01",
              y: 3000,
            },
            {
              x: "03/01",
              y: 2000,
            },
            {
              x: "04/01",
              y: 1000,
            },
            {
              x: "05/01",
              y: 3500,
            },
            {
              x: "06/01",
              y: 1500,
            },
            {
              x: "07/01",
              y: 2000,
            },
            {
              x: "08/01",
              y: 4000,
            },
            {
              x: "09/01",
              y: 2500,
            },
            {
              x: "10/01",
              y: 2300,
            },
            {
              x: "11/01",
              y: 1000,
            },
            {
              x: "12/01",
              y: 500,
            },
            {
              x: "13/01",
              y: 4000,
            },
            {
              x: "14/01",
              y: 3800,
            },
            {
              x: "15/01",
              y: 1200,
            },
            {
              x: "16/01",
              y: 700,
            },
            {
              x: "17/01",
              y: 1300,
            },
            {
              x: "18/01",
              y: 3000,
            },
            {
              x: "19/01",
              y: 1700,
            },
            {
              x: "20/01",
              y: 2100,
            },
            {
              x: "21/01",
              y: 1000,
            },
            {
              x: "22/01",
              y: 1900,
            },
          ],
        },
      ],
    };
  },
  computed: {
    dateRangeText() {
      return this.date.join(" ~ ");
    },
  },
  methods: {
    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split('T')[0];
      return formattedDate;
    },
  },
};
</script>
